// Pure IPC-2221 current-rating estimate for the PCB stator.
// No Angular / DI dependencies — math only, so it can be unit tested.
//
// The winding is a series chain (4 layers in series, two coils-per-phase in
// series), so the full phase current flows through ONE trace cross-section.
// The rating is therefore governed by a single trace, and the internal-layer
// limit binds because the chain must traverse In1/In2.

export interface CurrentRating {
  areaMm2: number;        // single-trace cross-section (mm²)
  areaMils2: number;      // converted for the IPC formula (mils²)
  internalAmps: number;   // governing limit, k = 0.024
  externalAmps: number;   // reference, k = 0.048 (= 2 × internalAmps)
}

const MM2_TO_MILS2 = 1550.0031;
const K_INTERNAL = 0.024;
const K_EXTERNAL = 0.048;

export function computeCurrentRating(
  traceWidthMm: number,
  copperOz: number,
  deltaTempC: number,
): CurrentRating {
  const copperThicknessMm = copperOz * 0.035;
  const areaMm2 = traceWidthMm * copperThicknessMm;
  const areaMils2 = areaMm2 * MM2_TO_MILS2;

  if (deltaTempC <= 0) {
    return { areaMm2, areaMils2, internalAmps: 0, externalAmps: 0 };
  }

  const factor = Math.pow(deltaTempC, 0.44) * Math.pow(areaMils2, 0.725);
  return {
    areaMm2,
    areaMils2,
    internalAmps: K_INTERNAL * factor,
    externalAmps: K_EXTERNAL * factor,
  };
}
